import { TOptions } from 'i18next';

import { Fragment } from 'react';

import { Card, FormItem } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { useTranslatedFormLabel, useUISchema } from '../hooks';
import { Schema } from '../queries';

interface Props {
  options?: TOptions;
  schemaId: string;
  schema: Schema;
  level?: number;
  path: string;
}

export function SchemaFormLabel({ path, schemaId, schema, options }: Props) {
  const label = useTranslatedFormLabel({ path, options });
  const level = path.split('.').length;

  const { isOptional } = useUISchema({ path, schemaId });
  const { t } = useTranslation();

  return (
    <Fragment>
      <FormItem.Label style={{ color: schema.type === 'object' && level > 2 ? 'var(--grey-66)' : 'inherit' }}>
        {label} {isOptional && `(${t('common.optional')})`}
      </FormItem.Label>

      {level > 2 && schema.type === 'object' && <Card.Separator />}
    </Fragment>
  );
}
